import React, { useContext, useEffect, useState } from 'react'
import EditProfile from './editProfile'
import CustomModal from '../../../component/customModal'
import ChangePassword from './changePassword'
import { Button } from 'reactstrap'
import TermsAndCondition from '../../../component/termsAndCondition'
import { useDispatch, useSelector } from 'react-redux'
import { SpinnerContext } from '../../../context/spinnerContext'
import { getUser } from '../../../redux/slices/authSlice'
import PaymentMethod from './paymentMethod'
import VerifyEmail from '../../../component/verifyEmail'
import { errorToast } from '../../../util/Toast/toast'

const Profile = () => {
  const dispatch = useDispatch()
  const { user } = useSelector(({ auth }) => auth)
  const { changeLoader } = useContext(SpinnerContext)

  const { isSocialLogin } = useSelector(({ auth }) => auth)

  const [isRefresh, setIsRefresh] = useState(true)
  const [showVerifyEmailModal, setShowVerifyEmailModal] = useState(false)
  const toggleVerifyEmailModal = () => setShowVerifyEmailModal(!showVerifyEmailModal)
  const [verificationEmail, setVerificationEmail] = useState(null)

  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false)
  const toggleChangePasswordModal = () => setShowChangePasswordModal(!showChangePasswordModal)

  const [showTermsandConditionModal, setShowTermsandConditionModal] = useState(false)
  const toggleTermsandConditionModal = () => setShowTermsandConditionModal(!showTermsandConditionModal)

  useEffect(() => {
    if (!isRefresh) return
    changeLoader(true)
    dispatch(getUser()).then(({ payload }) => {
      if (payload?.status === 200) {
        changeLoader(false)
        setIsRefresh(false)
      } else {
        changeLoader(false)
      }
    })
  }, [isRefresh])

  const handleChangePassword = () => {
    if (!user?.is_email_verified) {
      errorToast('Email not verified. Please verify email to continue')
      return
    }
    toggleChangePasswordModal()
  }
  return (
    <>
      <div className="page-wrapper">
        <div className="">
          <div className="heading_header_div">
            <div>
              <h4>Profile</h4>
              <p className="fs-14 black_color fw-400">Edit your info.</p>
            </div>
            <div className="list-btn mt-0">
              <ul className="filter-list">
                {!user?.is_term_accepted && (
                  <li>
                    <Button
                      className="btn btn-primary"
                      onClick={() => {
                        toggleTermsandConditionModal()
                      }}
                    >
                      <i className="fa-solid fa-file me-2" aria-hidden="true" />
                      Agree to Terms and Condition
                    </Button>
                  </li>
                )}
                {!user?.is_email_verified && (
                  <li>
                    <Button
                      className="btn btn-primary"
                      onClick={() => {
                        toggleVerifyEmailModal()
                        setVerificationEmail(user.email)
                      }}
                    >
                      <i className="fa-solid fa-envelope me-2" aria-hidden="true" />
                      Verify Email
                    </Button>
                  </li>
                )}
              </ul>
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-between"></div>
          <div className="card mb-0" style={{ border: '1px solid #57575733' }}>
            <div className="card-body">
              <h5 className="mb-3 edit_profile_text">Edit Your Profile</h5>
              <EditProfile showChangePasswordModal={showChangePasswordModal} />
              {isSocialLogin === false && (
                <div className="Change_Pass_sec">
                  <button
                    className="btn btn-primary paid-cancel-btn change_pass_btn mb-3"
                    type="button"
                    onClick={() => handleChangePassword()}
                    disabled={user?.is_freezed_client}
                  >
                    Change Password
                  </button>
                </div>
              )}
            </div>
          </div>

          <PaymentMethod />
        </div>
      </div>

      {showTermsandConditionModal && (
        <CustomModal isOpen={showTermsandConditionModal} toggle={toggleTermsandConditionModal} isTitle={false} size="lg">
          <TermsAndCondition setShowTermsandConditionModal={setShowTermsandConditionModal} setIsRefresh={setIsRefresh} />
        </CustomModal>
      )}

      {showChangePasswordModal && (
        <CustomModal isOpen={showChangePasswordModal} toggle={toggleChangePasswordModal} title={'Change Your Password'}>
          <ChangePassword setShowChangePasswordModal={setShowChangePasswordModal} />
        </CustomModal>
      )}

      {showVerifyEmailModal && (
        <CustomModal isOpen={showVerifyEmailModal} toggle={toggleVerifyEmailModal} isTitle={false}>
          <VerifyEmail verificationEmail={verificationEmail} toggleVerifyEmailModal={toggleVerifyEmailModal} />
        </CustomModal>
      )}
    </>
  )
}

export default Profile
